import React from 'react'
import { FormattedMessage } from 'react-intl'

export default {

  durations: {
    short: {
      'month': (<FormattedMessage id='premium.mo' defaultMessage='mo' />),
      'year': (<FormattedMessage id='premium.yr' defaultMessage='yr' />),
      'week': (<FormattedMessage id='premium.wk' defaultMessage='wk' />),
      'day': (<FormattedMessage id='premium.d' defaultMessage='d' />),
    },
    long: {
      'month': (<FormattedMessage id='premium.month' defaultMessage='month' />),
      'year': (<FormattedMessage id='premium.year' defaultMessage='year' />),
      'week': (<FormattedMessage id='premium.week' defaultMessage='week' />),
      'day': (<FormattedMessage id='premium.day' defaultMessage='day' />),
    },
  },

  errors: {
    'unknown': (
      <FormattedMessage
        id='premium.error.unknown'
        defaultMessage='An unknown error has occured, please try again.'
      />
    ),

    'product_fetch/1': (
      <FormattedMessage
        id='premium.error.product_fetch'
        defaultMessage='Unable to load products. Please try again.'
      />
    ),

    'card_declined': (
      <FormattedMessage
        id='premium.error.card_declined'
        defaultMessage='Sorry, your card was declined. Please try again with a different credit/debit card.'
      />
    ),

  },

  submittingActions: {

    'add_card': (
      <FormattedMessage
        id='premium.submitting.add_card'
        defaultMessage='Adding card'
      />
    ),

    'apply_coupon': (
      <FormattedMessage
        id='premium.submitting.apply_coupon'
        defaultMessage='Applying coupon'
      />
    ),

    'create_paid_subscription': (
      <FormattedMessage
        id='premium.submitting.create_paid_subscription'
        defaultMessage='Processing subscription'
      />
    ),

    'update_billing_profile': (
      <FormattedMessage
        id='premium.submitting.update_billing_profile'
        defaultMessage='Updating billing profile'
      />
    ),

  },

}



// WEBPACK FOOTER //
// ./src/components/premium/messages.js